import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getQueryString } from 'utils';

import VerifyCard from './components/VerifyCard';

import { verify } from '../../actions/session';
import { errorSet, errorClear } from 'actions/error';

//TODO refactor
export const Verify = (props) => {
  const {
    isAuth,
    history,
    errorSet,
    errorClear,
    dispatchVerify,
    error: { inputErrors }
  } = props;

  useEffect(() => {
    isAuth && history.replace('/orders');
  }, [isAuth, history]);

  const onVerify = ({ isValid, errors, values }) => {
    const getToken = () => getQueryString(props).get('token');

    const setErrors = () => errors && errorSet({ inputErrors: errors });

    const updatErrors = () => {
      errorClear();
      setErrors(errors);
    };

    const onSubmit = () => {
      updatErrors(errors);
      isValid && handleSubmit();
    };

    const handleSubmit = () => dispatchVerify({ ...values, token: getToken() });

    onSubmit();
  };

  return <VerifyCard errors={inputErrors} onVerify={onVerify} />;
};

let mapDispatchToProps = {
  errorSet,
  errorClear,
  dispatchVerify: verify
};

let mapStateToProps = ({ error, session }) => ({
  error,
  isAuth: session.isAuth
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Verify)
);
